export default __webpack_public_path__ + "static/media/Ammeraal Beltech.53e3ea15.png";